'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../../_virtual/_rollupPluginBabelHelpers.cjs');
var SdkError = require('../../errors/SdkError.cjs');

/**
 * @group Modules
 */
class ProgramClient {
  constructor(metaplex) {
    _rollupPluginBabelHelpers.defineProperty(this, "programs", []);
    this.metaplex = metaplex;
  }
  register(program) {
    this.programs.unshift(program);
  }
  all(overrides = []) {
    return [...overrides, ...this.programs];
  }
  allForCluster(cluster, overrides = []) {
    return this.all(overrides).filter(program => {
      return program.clusterFilter?.(cluster) ?? true;
    });
  }
  allForCurrentCluster(overrides = []) {
    return this.allForCluster(this.metaplex.cluster, overrides);
  }
  get(nameOrAddress, overrides = []) {
    const programs = this.allForCurrentCluster(overrides);
    const program = typeof nameOrAddress === 'string' ? programs.find(program => program.name === nameOrAddress) : programs.find(program => program.address.equals(nameOrAddress));
    if (!program) {
      throw new SdkError.ProgramNotRecognizedError(nameOrAddress, this.metaplex.cluster);
    }
    return program;
  }
}

exports.ProgramClient = ProgramClient;
//# sourceMappingURL=ProgramClient.cjs.map
